
import React, {useState} from 'react'
import { Offline, Online,Detector } from "react-detect-offline";


const DetectOffline = ()=> {

  const [online,setOnline] = useState(true)
  const [isOnCloud,setIsOnCloud] = useState()

  const renderOffline = ()=>{
      return (<div className="panel panel-danger text-center" style={{width:'450px',margin: 'auto'}}>
                    <div className="panel-heading">
                      <i className='spinner-border' />&nbsp; อินเตอร์เน็ตออฟไลน์
                    </div>
                    <div className="panel-body">
                        โปรดตรวจสอบสัญญาณ Internet
                    </div>
                </div>
      )
  }
  

  const renderOnline = ()=>{
      return (<div></div>)
  }

  const onNetworkChange = (online)=>{
      console.log('test',online)
      setOnline(online)

      if(online){
       
      }else{
       
      }
  }
  const polling = {
    enabled: false,
    interval: 10000,
    timeout: 1000
  };

  return (    
      <div>
        <div>            
            <Detector
                polling={polling}
                render={({ online }) => (
                    <div>{!online && (renderOffline())}</div>                   
                  )}
                onChange={(online)=>onNetworkChange(online)}
                />
        </div>
      </div>
    )  
}




export default DetectOffline;





